import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { CardForEventsData } from '@yme/molecules/cards/card-for-events/CardForEventsData';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { isExternalLink } from '@yme/utils/common';
import { BLANK, SELF } from '@yme/utils/constants';
import { EventPanel } from './EventPanel';
import { CardForEventsStyled, ImageBlockWrapperStyled, ImageWrapperStyled } from './styled';
const dataTestIdCard = 'CardForEventsId';
export function CardForEvents(props) {
    const { cardProps, isRightToLeft, callback } = props;
    const { image, title, description, link, labelLink, caption, additionalCaption, height = 'none', aspectRatio, eventLogo, flag, logoMaxHeight, marginBottom = 'auto', countLineVisible = 3, isFullHeaderVisible = false, isContainFit = false, isImageBackgroundHidden = false, } = cardProps;
    const isEventPanelNeeded = eventLogo || flag;
    const linkTarget = link && (isExternalLink(link) ? BLANK : SELF);
    const toRoute = link && isExternalLink(link)
        ? {
            pathname: link,
        }
        : link || '';
    const onClickHandler = useCallback(() => {
        if (callback) {
            callback();
        }
    }, [callback]);
    return (React.createElement(CardForEventsStyled, { marginBottom: marginBottom, isRightToLeft: isRightToLeft },
        React.createElement(FlexWrapper, { flexDirection: "column" },
            React.createElement(ImageBlockWrapperStyled, { to: toRoute, as: link ? Link : ImageBlockWrapperStyled, target: linkTarget },
                React.createElement(ImageWrapperStyled, { ...image, alt: image?.alt || '', heightValue: height, aspectRatio: aspectRatio, onClick: onClickHandler, dataTestId: dataTestIdCard, isLink: Boolean(link), isContainFit: isContainFit, isImageBackgroundHidden: isImageBackgroundHidden }),
                isEventPanelNeeded && (React.createElement(EventPanel, { logoMaxHeight: logoMaxHeight, eventLogo: eventLogo, flag: flag })))),
        React.createElement(CardForEventsData, { isFullHeaderVisible: isFullHeaderVisible, link: link, title: title, onClickHandler: onClickHandler, linkTarget: linkTarget, description: description, toRoute: toRoute, isRightToLeft: isRightToLeft, labelLink: labelLink, caption: caption, additionalCaption: additionalCaption, countLineVisible: countLineVisible })));
}
CardForEvents.displayName = 'CardForEvents_Molecule';
